module.exports = __webpack_public_path__ + "static/media/quora.cdcbfd16.svg";